module.exports = __webpack_public_path__ + "media/images/hitfun/logo.white-782c66a94058a910fd4599fd9948ce7c.svg";